import { Component, Input } from '@angular/core';
import { navItems } from './../../_nav';
import { GlobalService } from '../../services/global.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html'
})
export class DefaultLayoutComponent {
  year: number = new Date().getFullYear()// PR 1041;

  public navItems = navItems;
  public sidebarMinimized = true;
  private changes: MutationObserver;
  public element: HTMLElement = document.body;
  //userProfile = { username: 'User' }; //Commented for PR 991
  userProfile: any;//PR 991
  displayUserName: string; //PR 991

  constructor(
    private globalSerivce: GlobalService,
    private router: Router
  ) {

    this.changes = new MutationObserver((mutations) => {
      this.sidebarMinimized = document.body.classList.contains('sidebar-minimized');
    });

    this.changes.observe(<Element>this.element, {
      attributes: true
    });
  }

  ngOnInit() {
    this.userProfile = this.globalSerivce.getUserProfile();

    //PR 991 -Start
    if (this.userProfile.firstName
      && this.userProfile.lastName) {
      this.displayUserName = this.userProfile.firstName + " " + this.userProfile.lastName;
    }
    else if (this.userProfile.firstName) {
      this.displayUserName = this.userProfile.firstName;
    }
    else if (this.userProfile.lastName) {
      this.displayUserName = this.userProfile.lastName;
    }
    else if (this.userProfile.email) {
      this.displayUserName = this.userProfile.email;
    } else {
      this.displayUserName = "User";
    }
    //PR 991 -End

  }

  logout() {
    this.globalSerivce.logout();
  }

  redirectToSubscriptionPage() {
    console.log('function called');
    this.router.navigateByUrl('subscriptionList');
  }

  //PR 966 - START
  redirectToSubscriberPage() {
    this.router.navigateByUrl('subscriberList');
  }
  redirectToUserPage() {
    console.log('user function called')
    this.router.navigateByUrl('userList');
  }
  //PR 966 - END

  // PR 0983 - START
  redirectToServicePage() {
    this.router.navigateByUrl('serviceList');
  }
  // PR 0983 - END

  //PR 992 - START
  redirectToInvoicePage() {
    console.log('redirectToInvoicePage function called')
    this.router.navigateByUrl('invoiceList');
  }
  //PR 992 - END

  //PR 985 - START
  redirectToMsaPage() {
    console.log('redirectToMsaPage function called')
    this.router.navigateByUrl('msaList');
  }
  //PR 985 - END
  
  //PR 1066 - START
  redirectToSubscriptionJobsPage() {
    console.log('redirectToSubscriptionJobsPage function called')
    this.router.navigateByUrl('subscriptionJobsList');
  }
  //PR 1066 - END
}
